<template>
  <div class="contenedor-cpanel">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Mentorías</h1>
      <div class="barra"></div>
    </div>
    <div class="contenedor_botones_cpanel">
      <router-link to="/crear-mentoreado" class="botones_cpanel">Crear Mentoreado</router-link>
    </div>
    <h2>Mentorías en Curso</h2>
    <div class="contenedor_socios_lista" >
      <table id="tabla-anotados-lista">
        <thead>
          <th class="column_1">Nombre</th>
          <th class="column_1">Fecha de Inicio</th>
          <th class="column_5">Condición AAYI</th>
          <th class="column_4"></th>
        </thead>
        <tbody>
          <MentoriasAbiertasListaItem
            v-for="mentor in mentoriasAbiertas"
            :mentor="mentor"
            :key="mentor.mentoria_id"
            @refrescar="refrescar"
          ></MentoriasAbiertasListaItem>
        </tbody>
      </table>
    </div>
    <h2>Mentorías Finalizadas</h2>
    <div class="contenedor_socios_lista" >
      <table id="tabla-anotados-lista">
        <thead>
          <th class="column_1">Nombre</th>
          <th class="column_1">Fecha de Inicio</th>
          <th class="column_1">Fecha de Finalización</th>
          <th class="column_5">Observaciones</th>
          <th class="column_4"></th>
        </thead>
        <tbody>
          <MentoriasCerradasListaItem
            v-for="mentoria in mentoriasCerradas"
            :mentor="mentoria"
            :key="mentoria.mentoria_id"
            @refrescar="refrescar"
          ></MentoriasCerradasListaItem>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import MentoriasAbiertasListaItem from '../components/MentoriasAbiertasListaItem'
import MentoriasCerradasListaItem from '../components/MentoriasCerradasListaItem'
import mentorService from '../services/mentor'
export default {
  name: 'Mentorias',
  components: {
    BaseNotification2,
    MentoriasAbiertasListaItem,
    MentoriasCerradasListaItem
  },
  data: function () {
    return {
      mentoriasAbiertas: [],
      mentoriasCerradas: [],
      user: {
        persona_id: JSON.parse(localStorage.getItem('userData')).persona_id
      },
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    },
    refrescar () {
      mentorService
        .traerMentoriasAbiertasPorPersonaId(this.user.persona_id)
        .then(respuesta => {
          // this.cargando = false
          this.mentoriasAbiertas = respuesta
          console.log('Mentorias Abiertas:', respuesta)
        })
      mentorService
        .traerMentoriasCerradasPorPersonaId(this.user.persona_id)
        .then(respuesta => {
          // this.cargando = false
          this.mentoriasCerradas = respuesta
          console.log('Mentorias Cerradas:', respuesta)
        })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
    mentorService
      .traerMentoriasAbiertasPorPersonaId(this.user.persona_id)
      .then(respuesta => {
        // this.cargando = false
        this.mentoriasAbiertas = respuesta
        console.log('Mentorias Abiertas:', respuesta)
      })
    mentorService
      .traerMentoriasCerradasPorPersonaId(this.user.persona_id)
      .then(respuesta => {
        // this.cargando = false
        this.mentoriasCerradas = respuesta
        console.log('Mentorias Cerradas:', respuesta)
      })
  }
}
</script>

<style>

</style>
